import React from 'react';
import { Link } from 'react-router-dom';

/** Back to authenticated areas index. Blueprint: docs/INTERNAL_INDEX.md */
export default function InternalBackLink({ className = '', children = '← Internal' }) {
  return (
    <Link to="/internal" className={className || undefined}>
      {children}
    </Link>
  );
}
